/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { getProjects } from '@src/apis/project';
import { StyledProjectList } from './index.style';
import ProjectListHeader from './ProjectListHeader';
import ProjectListBody from './ProjectListBody';

const ProjectList = () => {
  const [projects, setProjects] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [searchResults, setSearchResults] = useState([]);
  const [activeSearching, setActiveSearching] = useState(false);

  const handleSearchInputChange = (e) => setSearch(e.target.value);

  const fetchProjects = async (hasLoading) => {
    if (hasLoading) setLoading(true);
    const response = await getProjects();
    if (response && response.status) {
      const projectsResult = response.result.projects;
      setProjects(projectsResult);
      setLoading(false);
    }
  };

  const handleSearch = () => {
    if (search.trim() !== '') {
      const searchResult = projects.filter((project) =>
        project.title.toLowerCase().includes(search.toLowerCase()),
      );
      setActiveSearching(true);
      setSearchResults(searchResult);
    } else {
      setSearchResults([]);
      setActiveSearching(false);
    }
  };

  useEffect(() => {
    handleSearch();
  }, [search]);

  useEffect(() => {
    fetchProjects(false);
  }, []);

  return (
    <StyledProjectList>
      <ProjectListHeader search={search} onSearch={handleSearchInputChange} />
      <ProjectListBody
        projects={projects}
        searchResults={searchResults}
        loading={loading}
        activeSearching={activeSearching}
      />
    </StyledProjectList>
  );
};

export default ProjectList;
